<template>
    <div class="lb-dashboard-school">
        <dashboard-school-header></dashboard-school-header>
        <user-members-table></user-members-table>
    </div>
</template>

<script>
import DashboardSchoolHeader from '@/components/DashboardSchoolHeader';
import UserMembersTable from '@/components/UserMembersTable';
export default {
    components: {
        DashboardSchoolHeader,
        UserMembersTable,
    },
};
</script>

<style scoped>
.lb-dashboard-school {
    margin-left: -0.75rem;
}
</style>
